<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-card-code>
          <b-row>
            <b-col md="3">
              <b-form-group label="Report Type">
                <v-select
                  v-model="reportType"
                  label="label"
                  :options="reportTypeOptions"
                  :clearable="false"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="From Date">
                <flat-pickr
                  v-model="fromDate"
                  class="form-control"
                  :config="dateConfig"
                  placeholder="Select from date"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="To Date">
                <flat-pickr
                  v-model="toDate"
                  class="form-control"
                  :config="dateConfig"
                  placeholder="Select to date"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Search Number / Name">
                <b-form-input v-model="search" placeholder="Enter number or name" />
              </b-form-group>
            </b-col>
            <b-col md="12" class="d-flex justify-content-end">
              <b-button variant="primary" @click="loadReport">Search</b-button>
            </b-col>
          </b-row>
        </b-card-code>
      </div>

      <div class="col-md-3 col-sm-6" v-for="item in summaryCards" :key="item.key">
        <div class="card">
          <div class="card-body">
            <h6 class="text-muted mb-50">{{ item.label }}</h6>
            <h3 class="mb-0">{{ item.value }}</h3>
          </div>
        </div>
      </div>

      <div class="col-12">
        <b-card-code>
          <div v-if="loading" class="text-center py-2">Loading call report...</div>
          <div v-else-if="error" class="text-danger py-2">{{ error }}</div>
          <report-table v-else :data="rows" :columns="columns">
            <template #printHeader>
              <div style="display:flex;justify-content:center;width:100%">
                <h3 style="margin:0">Call Report</h3>
              </div>
            </template>
          </report-table>
        </b-card-code>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axios'
import BCardCode from '@core/components/b-card-code'
import ReportTable from '@/components/ReportTable.vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import {
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BRow
} from 'bootstrap-vue'

const baseApi = process.env.VUE_APP_APIENDPOINT

export default {
  components: {
    BButton,
    BCardCode,
    BCol,
    BFormGroup,
    BFormInput,
    BRow,
    ReportTable,
    flatPickr,
    vSelect
  },
  data () {
    return {
      loading: false,
      error: '',
      rows: [],
      summary: {},
      search: '',
      fromDate: '',
      toDate: '',
      reportType: { label: 'All Calls', value: 'all' },
      reportTypeOptions: [
        { label: 'All Calls', value: 'all' },
        { label: 'Missed Calls', value: 'missed' },
        { label: 'Recordings Only', value: 'recordings' }
      ],
      dateConfig: {
        dateFormat: 'Y-m-d'
      },
      columns: [
        { field: 'started_at', label: 'Started At' },
        { field: 'direction', label: 'Direction' },
        { field: 'status', label: 'Status' },
        { field: 'remote_name', label: 'Remote Name' },
        { field: 'remote_number', label: 'Remote Number' },
        { field: 'extension_label', label: 'Extension' },
        { field: 'duration_text', label: 'Talk Time' },
        { field: 'recording_duration_text', label: 'Recording Time' },
        { field: 'callback_time_text', label: 'Callback Time' },
        { field: 'recording_url', label: 'Recording URL' }
      ]
    }
  },
  computed: {
    summaryCards () {
      return [
        { key: 'total_calls', label: 'Total Calls', value: this.summary.total_calls || 0 },
        { key: 'missed_calls', label: 'Missed Calls', value: this.summary.missed_calls || 0 },
        { key: 'recorded_calls', label: 'Recorded Calls', value: this.summary.recorded_calls || 0 },
        { key: 'callback_count', label: 'Callbacks', value: this.summary.callback_count || 0 }
      ]
    }
  },
  mounted () {
    this.loadReport()
  },
  methods: {
    async loadReport () {
      this.loading = true
      this.error = ''
      try {
        const response = await axios({
          method: 'GET',
          url: `${baseApi}/phone/reports/calls`,
          params: {
            report_type: this.reportType.value,
            from_date: this.fromDate || undefined,
            to_date: this.toDate || undefined,
            search: this.search || undefined
          }
        })
        const data = response.data.data || {}
        this.summary = data.summary || {}
        this.rows = (data.items || []).map(item => ({
          ...item,
          started_at: item.started_at ? new Date(item.started_at).toLocaleString() : '',
          extension_label: item.extension ? `${item.extension.label || ''} ${item.extension.extension || ''}`.trim() : '',
          duration_text: this.formatDuration(item.duration_seconds),
          recording_duration_text: this.formatDuration(item.recording_duration_seconds),
          callback_time_text: item.callback_time ? new Date(item.callback_time).toLocaleString() : ''
        }))
      } catch (error) {
        this.error = error.response?.data?.message || 'Unable to load call report.'
      } finally {
        this.loading = false
      }
    },
    formatDuration (seconds) {
      const total = Number(seconds || 0)
      const mins = Math.floor(total / 60)
      const secs = total % 60
      return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    }
  }
}
</script>
